export enum ProductName {
  Birthday = 'birthday',
  Campaign = 'campaign',
  ProxyCampaign = 'proxy_campaign',
  ProxyTeam = 'proxy_team',
  Team = 'team',
  InMemoryTeam = 'in_memory_team',
  ProxyFundraising = 'proxy_fundraising',
  Fundraising = 'fundraising',
  ProxyCharity = 'proxy_charity',
  ProxyEvent = 'proxy_event',
  SiteBuilder = 'site_builder',
  InMemory = 'in_memory',
}

export default ProductName;
